
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const CookiesPolicy = lazy(() => import('../pages/cookies-policy/page'));
const LegalNotice = lazy(() => import('../pages/legal-notice/page'));
const MediatorInfo = lazy(() => import('../pages/mediator-info/page'));
const NewsletterInfo = lazy(() => import('../pages/newsletter-info/page'));
const PaymentSuccess = lazy(() => import('../pages/payment-success/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy-policy/page'));
const PublicOffer = lazy(() => import('../pages/public-offer/page'));
const RefundPolicy = lazy(() => import('../pages/refund-policy/page'));
const SalesTerms = lazy(() => import('../pages/sales-terms/page'));
const TermsOfService = lazy(() => import('../pages/terms-of-service/page'));
const UsageTerms = lazy(() => import('../pages/usage-terms/page'));
const UserAgreement = lazy(() => import('../pages/user-agreement/page'));

const BurgundyPage = lazy(() => import('../pages/school/burgundy/page'));
const FoodPairingPage = lazy(() => import('../pages/school/food-pairing/page'));
const FranceWinesPage = lazy(() => import('../pages/school/france-wines/page'));
const FreeSparkling = lazy(() => import('../pages/school/free-sparkling/page'));
const LabelReadingPage = lazy(() => import('../pages/school/label-reading/page'));
const SparklingWinesPage = lazy(() => import('../pages/school/sparkling-wines/page'));
const WineShoppingPage = lazy(() => import('../pages/school/wine-shopping/page'));
const WineTermsPage = lazy(() => import('../pages/school/wine-terms/page'));

const SuccessBurgundyConnoisseur = lazy(() => import('../pages/success-burgundy-connoisseur/page'));
const SuccessBurgundyExplorer = lazy(() => import('../pages/success-burgundy-explorer/page'));
const SuccessBurgundyMaster = lazy(() => import('../pages/success-burgundy-master/page'));
const SuccessFoodpairingExplorer = lazy(() => import('../pages/success-foodpairing-explorer/page'));
const SuccessFoodpairingInsider = lazy(() => import('../pages/success-foodpairing-insider/page'));
const SuccessFoodpairingSommelier = lazy(() => import('../pages/success-foodpairing-sommelier/page'));
const SuccessFranceConnoisseur = lazy(() => import('../pages/success-france-connoisseur/page'));
const SuccessFranceExplorer = lazy(() => import('../pages/success-france-explorer/page'));
const SuccessFranceMaster = lazy(() => import('../pages/success-france-master/page'));
const SuccessLabelGuru = lazy(() => import('../pages/success-label-guru/page'));
const SuccessLabelMaster = lazy(() => import('../pages/success-label-master/page'));
const SuccessLabelReader = lazy(() => import('../pages/success-label-reader/page'));
const SuccessSparklingExplorer = lazy(() => import('../pages/success-sparkling-explorer/page'));
const SuccessSparklingMaster = lazy(() => import('../pages/success-sparkling-master/page'));
const SuccessSparklingPro = lazy(() => import('../pages/success-sparkling-pro/page'));
const SuccessWineShopping = lazy(() => import('../pages/success-wine-shopping/page'));
const SuccessWineTerms = lazy(() => import('../pages/success-wine-terms/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/burgundy',
    element: <BurgundyPage />,
  },
  {
    path: '/food-pairing',
    element: <FoodPairingPage />,
  },
  {
    path: '/france-wines',
    element: <FranceWinesPage />,
  },
  {
    path: '/free-sparkling',
    element: <FreeSparkling />,
  },
  {
    path: '/label-reading',
    element: <LabelReadingPage />,
  },
  {
    path: '/sparkling-wines',
    element: <SparklingWinesPage />,
  },
  {
    path: '/wine-shopping',
    element: <WineShoppingPage />,
  },
  {
    path: '/wine-terms',
    element: <WineTermsPage />,
  },
  {
    path: '/cookies-policy',
    element: <CookiesPolicy />,
  },
  {
    path: '/legal-notice',
    element: <LegalNotice />,
  },
  {
    path: '/mediator-info',
    element: <MediatorInfo />,
  },
  {
    path: '/newsletter-info',
    element: <NewsletterInfo />,
  },
  {
    path: '/payment-success',
    element: <PaymentSuccess />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/public-offer',
    element: <PublicOffer />,
  },
  {
    path: '/refund-policy',
    element: <RefundPolicy />,
  },
  {
    path: '/sales-terms',
    element: <SalesTerms />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfService />,
  },
  {
    path: '/usage-terms',
    element: <UsageTerms />,
  },
  {
    path: '/user-agreement',
    element: <UserAgreement />,
  },
  {
    path: '/success-burgundy-connoisseur',
    element: <SuccessBurgundyConnoisseur />,
  },
  {
    path: '/success-burgundy-explorer',
    element: <SuccessBurgundyExplorer />,
  },
  {
    path: '/success-burgundy-master',
    element: <SuccessBurgundyMaster />,
  },
  {
    path: '/success-foodpairing-explorer',
    element: <SuccessFoodpairingExplorer />,
  },
  {
    path: '/success-foodpairing-insider',
    element: <SuccessFoodpairingInsider />,
  },
  {
    path: '/success-foodpairing-sommelier',
    element: <SuccessFoodpairingSommelier />,
  },
  {
    path: '/success-france-connoisseur',
    element: <SuccessFranceConnoisseur />,
  },
  {
    path: '/success-france-explorer',
    element: <SuccessFranceExplorer />,
  },
  {
    path: '/success-france-master',
    element: <SuccessFranceMaster />,
  },
  {
    path: '/success-label-guru',
    element: <SuccessLabelGuru />,
  },
  {
    path: '/success-label-master',
    element: <SuccessLabelMaster />,
  },
  {
    path: '/success-label-reader',
    element: <SuccessLabelReader />,
  },
  {
    path: '/success-sparkling-explorer',
    element: <SuccessSparklingExplorer />,
  },
  {
    path: '/success-sparkling-master',
    element: <SuccessSparklingMaster />,
  },
  {
    path: '/success-sparkling-pro',
    element: <SuccessSparklingPro />,
  },
  {
    path: '/success-wine-shopping',
    element: <SuccessWineShopping />,
  },
  {
    path: '/success-wine-terms',
    element: <SuccessWineTerms />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
